import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "../../../../axios/index";

// Context
import { UserContext } from "../../../Context/UserContextProvider";

// components
import ShowProfileModal from "../../DashboardFileManagement/CardDetail/ShowProfileModal";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import { Pagination, Stack } from "@mui/material";

// Styles
import styles from "./../UserManagment.module.css";
import Dstyles from "./../../DashboardFileManagement/DashboardFileManagement.module.css";

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomPagination from "../../../CustomPagination/CustomPagination";

export default function RequestedFiles() {
  const { userToken } = useContext(UserContext);
  const [modalShow, setModalShow] = useState(false);

  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 5,
  });
  const [isLoading, setIsLoading] = useState(true);

  const [files, setFiles] = useState();
  const history = useHistory();

  useEffect(() => {
    const dataHandler = async () => {
      // setIsLoading(true)

      const getRequestes = await axios.get("RequestFile/FilterForAdmin?PageId=1&Take=6", {
        headers: { authorization: "Bearer " + userToken },
      });
      setPage(prev => {
        return { ...prev, pageNumber: 1, pageCount: getRequestes.data.data.pageCount };
      });
      // console.log(getRequestes.data.data.data)
      const requests = getRequestes.data.data.data;
      setFiles(requests);

      setIsLoading(false);
    };

    dataHandler();
  }, [userToken]);

  return (
    <>
      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <div className={`my-3 px-0 ${styles.file_cards_container}`}>
                <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                <div className="d-flex justify-content-start flex-wrap align-items-center mt-4 mx-4 px-2" dir="rtl">
                  <div className="d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2">
                    <a href="#" onClick={history.goBack}>
                      <img className="ms-2" src={arrowIcon} alt="icon" />
                    </a>
                    <div className={styles.text1}>فایل های درخواستی</div>
                  </div>
                </div>

                <div className="px-4">
                  <Cards files={files} />
                </div>

                <Stack
                  className={Dstyles.pagination}
                  spacing={1}
                  sx={{
                    direction: "ltr",
                    bottom: "0",
                    height: "85px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center !important",
                  }}>
                  <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={paginationHandler} />
                </Stack>
              </div>
            </div>
            <div className="col-md-3">
              {/* sideMenu starts */}
              <DashboardSideMenu manageUsers manageRequestedFiles />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );

  async function paginationHandler(event, value) {
    setIsLoading(true);
    const getRequestes = await axios.get(`RequestFile/FilterForAdmin?PageId=${value}&Take=6`, {
      headers: { authorization: "Bearer " + userToken },
    });
    setPage(prev => {
      return { ...prev, pageCount: getRequestes.data.data.pageCount, pageNumber: value };
    });
    const requests = getRequestes.data.data.data;
    setFiles(requests);
    setIsLoading(false);
  }
}

function Cards({ files }) {
  return (
    <>
      {files?.map(file => (
        <div key={file?.id} className={`w-100 d-flex align-items-center justify-content-between flex-wrap my-3 px-4 ${styles.requested_container}`} dir="rtl">
          <div className={styles.title_user_managment_card_box}>{file?.title}</div>
          <div className="d-flex align-items-center justify-content-center">
            <div className={`ms-2 ${styles.sellType_table_records_box}`}>نوع فایل درخواستی:</div>
            <div className={styles.sellType_table_records_box}>{file?.categoryTitle}</div>
          </div>
          <Link
            to={{
              pathname: `requested-file/${file.id}`,
              state: file,
            }}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.15533 0.96967C6.44822 1.26256 6.44822 1.73744 6.15533 2.03033L2.93566 5.25H10.875C11.2892 5.25 11.625 5.58579 11.625 6C11.625 6.41421 11.2892 6.75 10.875 6.75H2.93566L6.15533 9.96967C6.44822 10.2626 6.44822 10.7374 6.15533 11.0303C5.86244 11.3232 5.38756 11.3232 5.09467 11.0303L0.59467 6.53033C0.301777 6.23744 0.301777 5.76256 0.59467 5.46967L5.09467 0.96967C5.38756 0.676777 5.86244 0.676777 6.15533 0.96967Z"
                fill="#21409A"
              />
            </svg>
          </Link>
        </div>
      ))}
    </>
  );
}
